<script>
 import { createEventDispatcher } from 'svelte';

 export let defaultItem = "authors";
 export let droplist = ["titles", "tags"];
 export let selectedItem = defaultItem;

 const dispatch = createEventDispatcher();

 let hidelist = true;

 function selectItem(dropel) {
     selectedItem = dropel;
     hidelist = true;
 }
 function clickAndHide() {
     dispatch("dropdownClick");
     hidelist = !hidelist;
 }
</script>

<style>
 .showlist {
     @apply border-b-4 border-motw-red;
     display: table;
     z-index: 60;
 }
 .hidelist {
     @apply hidden;
 }
 .dropdown-li {
     @apply bg-white py-1 px-3 whitespace-no-wrap text-gray-800;
 }
 .dropdown-li:hover {
     @apply border-b-2 border-motw-red italic font-bold pl-2 pb-1;
 }

 li:nth-child(odd) {
     background-color: #e7e7e7;
 }
</style>

<div on:mouseleave={() => hidelist = true} class="dropdown inline-block relative">
    <button on:click={clickAndHide} class="monocle:text-sm phone:text-sm bg-motw-red text-white font-bold p-2 inline-flex items-center text-lg focus:outline-none active:text-red-200">
        <span class="mr-1">{defaultItem.toUpperCase()}</span>
        <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
            <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
        </svg>
    </button>
    <ul class:hidelist class:showlist={!hidelist} class="dropdown-menu absolute text-white pt-1 w-full monocle:text-sm phone:text-sm text-lg cursor-pointer">
        {#each droplist as dropel}
            <li class="dropdown-li"
                on:click="{() => selectItem(dropel)}">{dropel.toUpperCase()}</li>
        {/each}
    </ul>
</div>
